import React from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';
import { getDateString, isBase64Image } from '../../helpers/utils';
import { Credential } from '../../types/credentials';

interface OfferDetailsProps {
  credential: Credential;
}

/**
 * @description Offer details component
 * @param {OfferDetailsProps} { credential }
 * @return {React.FC}
 */
const OfferDetails: React.FC<OfferDetailsProps> = ({ credential }) => {
  const mapKey = (key: string): string => {
    const mapped = key.charAt(0).toUpperCase() + key.slice(1);
    return mapped.replace(/_/g, ' ');
  };

  return (
    <View style={styles.cardAttributes}>
      <View style={styles.cardAttribute}>
        <Text style={styles.attributeName}>Issued By</Text>
        <Text style={styles.attributeValue}>{credential.issuer}</Text>
      </View>
      {credential.attributes.map((item, index) => {
        let value = item.value;
        if (item.name.toLowerCase().includes('date') && !isNaN(Number(value))) {
          value = getDateString(Number(value));
        }
        return (
          <View key={item.name} style={styles.cardAttribute}>
            <View style={styles.attributeTitle}>
              <Text style={styles.attributeName}>{mapKey(item.name)}</Text>
            </View>
            <View style={index !== credential.attributes.length - 1 && styles.attributeBorder}>
              {isBase64Image(value) || value.includes('https://') ? (
                <View style={styles.attributeImageContainer}>
                  <Image source={{ uri: value }} style={styles.attributeImage} />
                </View>
              ) : (
                <Text style={styles.attributeValue}>{value}</Text>
              )}
            </View>
          </View>
        );
      })}
    </View>
  );
};

export default OfferDetails;

const styles = StyleSheet.create({
  attributeName: {
    fontSize: 14,
    color: '#30394C',
    fontWeight: '400'
  },
  attributeValue: {
    fontSize: 18,
    color: '#30394C',
    fontWeight: '400'
  },
  cardAttributesSectionTitle: {
    marginBottom: 8,
    fontSize: 16,
    fontWeight: '700'
  },
  cardAttributes: {
    display: 'flex',
    gap: 1,
    borderRadius: 6,
    overflow: 'hidden'
  },
  cardAttribute: {
    paddingTop: 12,
    paddingRight: 0,
    paddingBottom: 14,
    paddingLeft: 0
  },
  attributeImageContainer: {
    marginTop: 6,
    width: 256,
    aspectRatio: '1/1',
    overflow: 'hidden',
    borderRadius: 6
  },
  attributeImage: {
    width: '100%',
    height: '100%'
  },
  attributeTitle: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  attributeBorder: {
    borderBottomWidth: 1,
    borderColor: '#CECECE',
    paddingBottom: 5
  }
});
